<template>
	<div class="order-detail order-pay" v-show="loaded">
		<div class="pay-detail bg-white">
			<div class="space"></div>
			<div class="row">
				<div class="pull-left">应付金额</div>
				<div class="yellow pull-right">
					￥<span v-text="order.to_pay_amount"></span>
				</div>
			</div>
			<div class="row bg-grey">
				<div>
					请选择支付方式
				</div>
			</div>
			<div class="row mr-20" :class="{'border-line': index < ways.length - 1}" v-for="(item, index) in ways" :key="item.kindId" @click="onWaysClick(index)">
				<div class="pull-left">
					<p style="margin-top:3px;margin-bottom:0;">
						{{ item.title }}<span class="yellow" style="margin: 5px 0 0 0; font-size:13px;" v-if="item.tips"> {{ item.tips }}</span>
					</p>
				</div>
				<div class="pull-right"><span class='ic-arrow'></span></div>
			</div>
			<div class="row bg-grey" style="height:150px; border-bottom: 1px dashed #ccc;">
			</div>
			<div class="row bg-grey">
				<div style="text-align:center;color: #64a0e5;" @click="onQaClick">
					以上支付方式不可用?
				</div>
			</div>
			<div class="row bg-grey" v-show="showTransOps">
				<div style="color: #64a0e5;">您需先自行去转账，然后在此登记查账信息</div>
			</div>
			<div class="row mr-20" :class="{'border-line': index < trans.length - 1}" v-for="(item, index) in trans" :key="item.kindId" @click="onTransClick(index)" v-show="showTransOps">
				<div class="pull-left">
					<p style="margin-top:3px;margin-bottom:0;">
						{{ item.title }}<span class="yellow" style="margin: 5px 0 0 0; font-size:13px;" v-if="item.tips"> {{ item.tips }}</span>
					</p>
				</div>
				<div class="pull-right"><span class='ic-arrow'></span></div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { MessageBox } from 'mint-ui'

export default {
	name: 'Payways',
	data: function () {
		return {
			'loaded': false,
			'showTransOps': false,
			'ways': [
				{'kindId': 2, 'title': '整单支付', 'tips': '', 'url': 'PayOnline'},
				{'kindId': 1, 'title': '拆单支付', 'tips': ' (金额大于1万元时，推荐使用)', 'url': 'PaySplit'}
			],
			'trans': [
				{'kindId': 5, 'title': '查看我司收款账号', 'tips': '', 'url': 'TransAccountsHelp'},
				{'kindId': 3, 'title': '我已完成转账, 自行填写查账信息', 'tips': '', 'url': 'TransList'},
				{'kindId': 4, 'title': '我已完成转账, 委托服务助理填写查账信息', 'tips': '', 'url': 'TransDelegate'}
			]
		}
	},
	computed: {
		...mapGetters({
			order: 'getOrder',
			page: 'getPage'
		})
	},
	created () {
		this.showTransOps = this.page.showTransOps || false
		this.fetchDetail()
	},
	components: {
	},
	mounted: function () {
		this.setPageTitle('订单支付')
		this.fetchPayChannels()
		this.showChoosePay()
	},
	methods: {
		showChoosePay() {
			if (this.order.syn_cms_status !== 0) {
				this.trans = [
					{'kindId': 5, 'title': '查看我司收款账号', 'tips': '', 'url': 'TransAccountsHelp'},
					{'kindId': 3, 'title': '我已完成转账, 自行填写查账信息', 'tips': '', 'url': 'TransList'}
				]
			}
		},
		onQaClick () {
			this.showTransOps = !this.showTransOps
			this.$store.dispatch('setPage', { 'showTransOps': this.showTransOps })
			console.log('page: ', this.page.showTransOps)
		},
		onWaysClick (index) {
			let item = this.ways[index]
			this.$store.dispatch('setPage', { 'showTransOps': false })
			this.$router.push({name: item.url, params: this.$route.params})
		},
		onTransClick (index) {
			let item = this.trans[index]
			if (item.url === 'TransList') {
				this.$store.dispatch('setSelectedPayway', {'item': {'routeCode': 'P0000'}})
				this.$router.push({name: item.url})
			} else if (item.url === 'TransDelegate') {
				this.toStaffFillIn()
			} else {
				this.$router.push({name: item.url})
			}
		},
		checkPayKind () {
			if (this.order.paid_price > 0 && this.order.pay_kind === 20) {
				window.location.href = '?#/pay/split/' + this.order.order_no
			} else if (this.order.pay_kind === 30) {
				window.location.href = '#/trans/' + this.order.order_no
			}
		},
		fetchDetail () {
			if (this.order && this.order.pay_price) {
				this.loaded = true
				this.checkPayKind()
				return
			}
			this.getOrderSimpleDetail(this.$route.params.id, order => {
				this.checkPayKind()
				this.loaded = true
			})
		},
		toStaffFillIn () {
			MessageBox.confirm('请将您的转账凭证发送给您的专属服务助理，由TA代替您提交查账信息, 完成后TA会通知您完成后续操作').then(action => {
				console.log(action)
				if (action === 'confirm') {
					let url = '/api/orders/payments/trans/delegate/' + this.$route.params.id
					this.$http.post(url).then(response => {
						this.loadingHide()
						var rs = response.body
						if (rs.code === 0) {
							// this.$router.replace('/orders/pay/success/' + this.$route.params.id)
							this.$router.replace('/orders/verify/' + this.$route.params.id)
						} else {
							this.handleHttpError(response)
						}
					}, response => {
						console.log(response)
						this.handleHttpError(response)
					})
				}
			}, action => {})
		}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/payment/Payways.vue